var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBitcoinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#091C00",
    fillOpacity: 0.8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1440_3951)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.641 24.902C32.0377 31.334 25.521 35.244 19.0982 33.6406C12.666 32.0373 8.75611 25.5209 10.3595 19.0982C11.9628 12.6662 18.47 8.75623 24.9022 10.3596C31.325 11.9536 35.2444 18.47 33.641 24.902Z",
    fill: "url(#paint0_linear_1440_3951)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7141 20.5048C27.9484 18.911 26.7391 18.0485 25.0703 17.4767L25.6141 15.311L24.3016 14.9829L23.7766 17.0923C23.4297 17.0079 23.0734 16.9235 22.7172 16.8485L23.2422 14.7298L21.9297 14.4017L21.3953 16.5579C21.1047 16.4923 20.8234 16.4267 20.5516 16.361V16.3517L18.7328 15.9017L18.3859 17.3079C18.3859 17.3079 19.3609 17.5329 19.3422 17.5423C19.8766 17.6735 19.9703 18.0298 19.9516 18.311L19.3328 20.7767C19.3703 20.786 19.4172 20.7954 19.4734 20.8235C19.4266 20.8142 19.3797 20.8048 19.3328 20.786L18.4703 24.236C18.4047 24.3954 18.2359 24.6392 17.8703 24.5454C17.8797 24.5642 16.9141 24.311 16.9141 24.311L16.2578 25.8204L17.9734 26.2517C18.2922 26.336 18.6016 26.411 18.9109 26.4954L18.3672 28.6798L19.6797 29.0079L20.2234 26.8423C20.5797 26.936 20.9359 27.0298 21.2734 27.1142L20.7391 29.2704L22.0516 29.5985L22.5953 27.4142C24.8453 27.836 26.5328 27.6673 27.2359 25.6329C27.8078 24.0017 27.2078 23.0548 26.0266 22.436C26.8984 22.2392 27.5453 21.6673 27.7141 20.5048ZM24.7047 24.7235C24.3016 26.3548 21.5453 25.4735 20.6547 25.2485L21.3766 22.3517C22.2672 22.5767 25.1359 23.0173 24.7047 24.7235ZM25.1172 20.4767C24.7422 21.9673 22.4547 21.2079 21.7141 21.0204L22.3703 18.3954C23.1109 18.5829 25.5016 18.9298 25.1172 20.4767Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1440_3951",
    x1: 21.9935,
    y1: 9.99436,
    x2: 21.9935,
    y2: 33.9977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9AA4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1440_3951"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitcoinIcon);
export default __webpack_public_path__ + "static/media/bitcoin_icon.2cf9baf7beadd3d54f2a9e0c294b6d80.svg";
export { ForwardRef as ReactComponent };